import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetMenusForSelectResponse } from '../../layout/models/get-menus-for-select-response';
import { GetMenusByRoleResponse } from '../../layout/models/get-menus-by-role-id-response';

@Injectable({
    providedIn: 'root'
})
export class MenuApi {
    http = inject(HttpClient);
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    baseUrl = `${environment.apiUrl}/menu`;

    getMenusByRoleId(roleId: string) {
        return this.http.get<GetMenusByRoleResponse>(`${this.baseUrl}/role/${roleId}`, this.httpOptions);
    }

    getMenusForSelect() {
        return this.http.get<GetMenusForSelectResponse>(`${this.baseUrl}/select`, this.httpOptions);
    }
}
